var render = function render(){var _vm=this,_c=_vm._self._c;return (this.title)?_c('UiValue',{attrs:{"title":this.title,"value":this.value,"um":this.um,"img":this.img,"updatedAt":this.updatedAt}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }